import { ApiCorporate, Corporate } from './corporate.types'

export function parseApiCorporate({ ...corporateData }: ApiCorporate): Corporate {
  return {
    ...corporateData,
  }
}
